import React, { FC, Fragment } from 'react';
import { Grid, Skeleton } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';

type Props = {
  count: number;
};

const NotificationSkeletonLoader: FC<Props> = ({ count }) => {
  return (
    <Grid className={styles.container}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid
          key={index}
          className={styles.skeletonItem}
          data-testid="notification-skeleton-item"
        >
          <Skeleton variant="rounded" height={20} width="60%" />
          <Skeleton variant="rounded" height={16} width="100%" />
          <Skeleton variant="rounded" height={12} width="20%" />
        </Grid>
      ))}
    </Grid>
  );
};

export default NotificationSkeletonLoader;
